var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMvWgEmptyImgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "69px",
    viewBox: "0 0 92 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Img") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hi-Fi-WG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.838950893
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Gallery-Empty-State",
    transform: "translate(-573.000000, -270.000000)",
    fill: "#DBDBDB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Img",
    transform: "translate(573.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,69 L92,69 L92,0 L0,0 Z M2.09090909,2.09090909 L89.9090909,2.09090909 L89.9090909,57.9244545 L69.7840909,35.8716364 C69.55131,35.6143605 69.1796927,35.4877559 68.8366477,35.5449318 C68.6120423,35.5857673 68.4037668,35.7041964 68.2485795,35.8716364 L52.5019432,52.5989091 L30.0570795,27.508 C29.8242986,27.2507241 29.4526814,27.1241195 29.1096364,27.1812955 C28.8850309,27.2221309 28.6767555,27.34056 28.5215682,27.508 L2.09143182,55.8983636 L2.09090909,2.09090909 Z M53.3181818,14.6363636 C49.2874318,14.6363636 46,17.9237955 46,21.9545455 C46,25.9852955 49.2874318,29.2727273 53.3181818,29.2727273 C57.3489318,29.2727273 60.6363636,25.9852955 60.6363636,21.9545455 C60.6363636,17.9237955 57.3489318,14.6363636 53.3181818,14.6363636 Z M52.7954545,16.7272727 C52.9710595,16.7109427 53.1384891,16.7272727 53.3181818,16.7272727 C56.2176455,16.7272727 58.5454545,19.0550818 58.5454545,21.9545455 C58.5454545,24.8540091 56.2176455,27.1818182 53.3181818,27.1818182 C50.4187182,27.1818182 48.0909091,24.8540091 48.0909091,21.9545455 C48.0909091,19.2346909 50.1492,16.9927136 52.7954545,16.7272727 Z M29.2403182,29.7630455 L62.4983182,66.9090909 L2.09091118,66.9090909 L2.09091118,58.9048818 L29.2403182,29.7630455 Z M69,38.1266818 L89.9090909,61.0284091 L89.9090909,66.9090909 L65.3085,66.9090909 L53.9067727,54.1670909 L69,38.1266818 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvWgEmptyImgIcon);
export default __webpack_public_path__ + "static/media/mv-wg-empty-img-icon.2f0f26733296595a801abdc48fabc5c3.svg";
export { ForwardRef as ReactComponent };